/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div class="item-position project-alarm">
    <div class="title-item">
      <div class="first"></div>
      <div class="two">03</div>
      <div class="title">
        <div>Alarm monitoring</div>
        <div>{{$t('alarmMonitor')}}</div>
      </div>
    </div>
    <div class="alarm-title">
      <div :class="{'click':isRunInfo}" @click="itemClick()">{{$t('alarmDetail')}}</div>
      <div :class="{'click':!isRunInfo}" @click="itemClick(1)">{{$t('peccancyDetail')}}</div>
    </div>
    <div class="alarm-split"></div>
    <div class="alarm-content" v-if="isRunInfo">
      <div class="info-item" v-for="(item,index) of alarmList" :key="index">
        <div class="title">{{item.craneName}}</div>
        <div class="time">{{item.startTime}}</div>
        <div class="time">{{item.endTime}}</div>
        <div class="content" :style="{color: '#f2994a'}">{{item.content}}</div>
      </div>
    </div>
    <div class="alarm-content" v-if="!isRunInfo">
      <div class="info-item" v-for="(item,index) of peccancyList" :key="index">
        <div class="title">{{item.craneName}}</div>
        <div class="time">{{item.startTime}}</div>
        <div class="time">{{item.endTime}}</div>
        <div class="content" :style="{color: '#eb5757'}">{{item.content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlarmMonitor',
  data () {
    return {
      isRunInfo: true
    }
  },
  props: {
    alarmList: {
      type: Array
    },
    peccancyList: {
      type: Array
    }
  },
  methods: {
    itemClick (type) {
      this.isRunInfo = !type
    }
  }
}
</script>

<style scoped lang="scss">
  .project-alarm{
    z-index: 2;
    left: 10px;
    top: 630px;
    width: 355px;
    .alarm-title{
      display: flex;
      justify-content: space-between;
      color:rgba(255,255,255,0.3);
      div{
        width:165px;
        height:26px;
        background-color: rgba(4,30,48,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        cursor:pointer;
      }
      .click{
        color: #15c5e8 !important;
        border-bottom:  1px solid #15c5e8 !important;
      }
    }
    .alarm-split{
      width:100%;
      height:3px;
      background-size: 100% 100%;
      background: url('/static/img/splitLine3.png') center center no-repeat;
      margin-top: 6px;
    }
    .alarm-content{
      background-color: rgba(4,30,48,0.5);
      width:100%;
      height:360px;
      font-size: 14px;
      margin-top: 6px;
      overflow: hidden;
      .info-item{
        height:30px;
        width:100%;
        display: flex;
        align-items: center;
        padding:0 5px;
        color: #fff;
        .title{
          width:60px;
        }
        .time{
          width:80px;
        }
        .content{
          overflow:hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
          width:125px;
          display: flex;
          align-items: center;
        }
      }
      .info-item:nth-child(odd){
        background-color:rgba(8,43,65,0.7)
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AlarmMonitor.vue